import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as Const from 'util/constants';

import { priceRegular, pricePremium, priceAudioMegaBundle, priceUltimate } from 'actions/order';

export function Summary({ bundle, template, bundleType, className }) {
  let title = 'Doodly Marketplace Ultimate';
  let price = priceUltimate;
  switch (bundleType) {
    case Const.TYPE_IMAGE_BUNDLES:
      title = bundle ? `${bundle.name} Asset Bundle` : '';
      price = bundle ? (bundle.is_premium ? pricePremium : priceRegular) : 0;
      break;
    case Const.TYPE_AUDIO_BUNDLES:
      title = bundle ? bundle.name : '';
      price = bundle ? priceAudioMegaBundle : 0;
      break;
    case Const.TYPE_TEMPLATES:
      title = template ? `${template.title} Template` : '';
      price = template ? priceRegular : 0;
      break;
    default:
  }
  return (
    <div className={classNames('summary', className)}>
      <h4>Summary</h4>
      <div className="item d-flex justify-content-between">
        <div className="title mr-3">{title}</div>
        <div className="price">${price}</div>
      </div>
      <div className="total d-flex justify-content-between">
        <div className="title mr-3">Total:</div>
        <div className="price">${price}</div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const { bundles, templates } = state;
  return {
    bundle: bundles.currentBundle,
    template: templates.currentTemplate,
  };
};

export default connect(mapStateToProps, {})(Summary);
